<template>
  <div style="background-color: white">

    <div class="no-display">
      <v-btn
        @click="prevPage"
        color="primary"
        class="ml-5 mr-5"
        :disabled="currentPage === 1"
        >Previous Page</v-btn
      >
      <!-- {{ currentPage }} -->
      <v-btn
        @click="nextPage"
        color="primary"
        class="ml-5 mr-5"
        :disabled="currentPage === totalPages"
        >Next Page</v-btn
      >
      <v-btn @click="print" color="primary" class="ml-5 mr-5" warning
        >Print</v-btn
      >
    </div>

    <div v-for="(stud_data, ind) in displayedItems" :key="ind">
      <div class="" style="background-color: white">
        <div style="width: 19rem">
          <div>
            <div
              class="row ml-0"
              style="height: 110px; margin-top: 0px"
            >
              <div class="col-1" style="margin-top: 0px">
                <img
                  :src="common_data.logo"
                  style="width: 100px; height: 100px; margin-left: -8px;"
                  alt="logo"
                />
              </div>
              <!-- logo end -->
              <div class="col-11" style="margin-top: 3px">
                <b>
                  <span
                    style="
                      text-transform: uppercase;
                      line-height: 1;
                      
                      margin-left: 65px;
                      font-family: 'Vogue';
                      font-size: 13px;
                    "
                  >
                    {{common_data.school_name}}
                  </span>
                </b>
                <!-- school name -->
                <div
                  style="
                    border-bottom: 1px solid black;
                    width: 75%;
                    margin-left: 65px;
                    margin-bottom: -5px;
                  "
                ></div>
                <!-- white line -->
                <div
                  class="mdi mdi-map-marker"
                  style="
                   
                    margin-left: 65px;
                    font-size: 11px;
                    margin-top: 6px;
                  "
                >
                  {{ common_data.school_address }}
                </div>
                <!-- address end  -->
              </div>
            </div>
            <div
              class="row ml-0"
              style="
                background-color: #f5e8ca;
                height: 4px;
                justify-content: center;
              "
            ></div>
            <!-- yellow line -->
            <div
              v-if="stud_data.icard_temp.child_photo.field_value"
              class="row"
              style="
                justify-content: center;
                margin-top: 5px;
                margin-bottom: 5px;
                margin-left: 2px;
              "
            >
              <img
                v-if="stud_data.icard_temp.child_photo.field_value"
                style="border: 3px solid #035a8f"
                :src="stud_data.icard_temp.child_photo.field_value"
                width="120px"
                height="120px"
                alt="child photo"
              />
            </div>
            <!-- child photo  -->
            <div
              class="row ml-0"
              style="
                background-color: #035a8f;
                height: 25px;
                justify-content: center;
              "
            >
              <h3 style="color: white; margin-left: 0px">
                <span v-if="stud_data.icard_temp.firstname.field_value">
                  {{ stud_data.icard_temp.firstname.field_value }}
                </span>
                <span v-if="stud_data.icard_temp.lastname.field_value">
                  {{ stud_data.icard_temp.lastname.field_value }}
                </span>
              </h3>
            </div>
            <!-- child name  -->
            <div style="position: relative">
              <div
                class="row"
                style="
                  justify-content: center;
                  margin-top: -10px;
                  height: 200px;
                  font-size: 14px;
                  margin-left: 17px;
                "
              >
                <div class="col-6">
                  <span> Grade: </span
                  ><span
                    ><b> {{ stud_data.icard_temp.std }} </b></span
                  >
                </div>
                <div class="col-6">
                  <span> DOB.: </span
                  ><span
                    ><b>{{ stud_data.icard_temp.stud_dob }} </b></span
                  >
                </div>
                <div class="col-6" style="margin-top: -20px">
                  <span> PRN No.: </span
                  ><span
                    ><b>{{ stud_data.icard_temp.grno }}</b></span
                  >
                </div>
                <div class="col-6" style="margin-top: -20px">
                  <span> Blood Group: </span><span><b> {{ stud_data.icard_temp.stud_blood_group }} </b></span>
                </div>
                <div class="col-12" style="margin-top: -20px">
                  <span> Transportation Mode: </span
                  ><span><b> {{ stud_data.icard_temp.transportation_mode.field_value }} </b></span>
                </div>
                <div v-if="stud_data.icard_temp.emergency_contact_number.field_value" class="col-12" style="margin-top: -20px">
                  <span> Emergency Contact No.: </span
                  ><span
                    ><b>
                      {{ stud_data.icard_temp.emergency_contact_number.field_value }}</b
                    ></span
                  >                  
                </div>
                <v-row dense>
                  <v-col cols="12" sm="3" class="pl-5">
                    <qrcode-vue
                      style=""
                      :value="stud_data.icard_temp.grno"
                      :size="75"
                    ></qrcode-vue>
                  </v-col>
                  <v-col cols="12" sm="4"></v-col>
                  <v-col cols="12" sm="4" class="mt-4 ml-5">
                    <img
                      :src="common_data.sign"
                      alt="signature"
                      style="width: 70px; height: 40px"
                    />
                    <b>Auth.Sign.</b>
                  </v-col>
                </v-row>
              </div>
              <div
                class="row ml-0"
                style="
                  background-color: #035a8f;
                  height: 18px;
                  position: relative;
                  margin-top: 17px;
                "
              ></div>
            </div>
          </div>

          <div class="pagebreak" style="height: 493px">
            <div
              class="row ml-0"
              style="height: 110px; margin-top: 0px"
            >
              <div class="col-1" style="margin-top: -3px">
                <img
                  :src="common_data.logo"
                  style="width: 105px; height: 105px; margin-left: -8px; "
                  alt="logo"
                />
              </div>
              <div class="col-11" style="margin-top: 0px">
                <b>
                  <span
                    style="
                      text-transform: uppercase;
                      line-height: 1;
                      
                      margin-left: 65px;
                      font-family: 'Vogue';
                      font-size: 13px;
                    "
                  >
                    {{common_data.school_name}}
                  </span>
                </b>
                <!-- school name  -->
                <div
                  style="
                    border-bottom: 1px solid black;
                    width: 75%;
                    margin-left: 65px;
                    margin-bottom: -5px;
                  "
                ></div>
                <!-- white line -->
                <div
                  class="mdi mdi-map-marker mt-2"
                  style="margin-left: 65px; font-size: 11px"
                >
                  {{ common_data.school_address }}
                </div>
                <!-- address end  -->
              </div>
            </div>
            <div
              class="row ml-0"
              style="
                background-color: #f5e8ca;
                height: 5px;
                justify-content: center;
              "
            ></div>
            <!-- yellow line -->
            <div class="row" style="justify-content: center; margin-top: 10px">
              <span style="font-weight: 500"> Parent Details</span>
            </div>
            <div class="row" style="justify-content: center; margin-top: 10px">
              <div style="margin-right: 15px; width: 6rem">
                <span
                  style="position: relative"
                  v-if="stud_data.icard_temp.father_photo.field_value"
                >
                  <center>
                    <span
                      v-if="stud_data.icard_temp.father_photo.field_value"
                      style="
                        position: absolute;
                        border-top: 5px solid #f5e8ca;
                        border-left: 5px solid #f5e8ca;
                        width: 35px;
                        height: 35px;
                        top: -5px;
                        left: -5px;
                      "
                    ></span>
                    <img
                      style="border: 3px solid #035a8f"
                      v-if="stud_data.icard_temp.father_photo.field_value"
                      :src="stud_data.icard_temp.father_photo.field_value"
                      width="110px"
                      height="110px"
                    />
                    <span
                      v-if="stud_data.icard_temp.father_photo.field_value"
                      style="
                        position: absolute;
                        border-right: 5px solid #f5e8ca;
                        border-bottom: 5px solid #f5e8ca;
                        width: 35px;
                        height: 35px;
                        bottom: 2.5px;
                        right: -20%;
                      "
                    ></span>
                  </center>
                </span>
                <span style="position: relative" v-else>
                  <center>
                    <span
                      style="
                        position: absolute;
                        border-top: 5px solid #f5e8ca;
                        border-left: 5px solid #f5e8ca;
                        width: 35px;
                        height: 35px;
                        top: -5px;
                        left: -5px;
                      "
                    ></span>
                    <img
                      style="border: 3px solid #035a8f"
                      alt=""
                      :src="stud_data.icard_temp.father_photo.field_value"
                      width="110px"
                      height="110px"
                    />
                    <span
                      style="
                        position: absolute;
                        border-right: 5px solid #f5e8ca;
                        border-bottom: 5px solid #f5e8ca;
                        width: 35px;
                        height: 35px;
                        bottom: 2.5px;
                        right: -20%;
                      "
                    ></span>
                  </center>
                </span>
                <span
                  v-if="stud_data.icard_temp.father_full_name"
                  class="text-center"
                >
                  <h5
                    style="
                      color: #035a8f;
                      height: 50px;
                      font-size: 13px;
                      line-height: 12px;
                      width: 110px;
                      font-weight: bold;
                      padding-top: 2px;
                    "
                  >
                    {{ stud_data.icard_temp.father_full_name.field_value }}
                  </h5>
                </span>

                <div
                  class="text-center"
                  style="margin-top: -10px"
                  v-if="stud_data.icard_temp.father_mobile_no"
                >
                  <h5>
                    <span style="font-weight: 400; font-size: 14px">
                      Contact No. : </span
                    ><br />
                    <span style="font-size: 14px">{{
                      stud_data.icard_temp.father_mobile_no.field_value
                    }}</span>
                  </h5>
                </div>
              </div>
              <div
                style="
                  border-right: #035a8f 1.5px dotted;
                  margin-right: 15px;
                  width: 1rem;
                "
              ></div>
              <div style="width: 6rem; margin-left: 0px">
                <span
                  style="position: relative"
                  v-if="stud_data.icard_temp.mother_photo.field_value"
                >
                  <center>
                    <span
                      v-if="stud_data.icard_temp.mother_photo.field_value"
                      style="
                        position: absolute;
                        border-top: 5px solid #f5e8ca;
                        border-left: 5px solid #f5e8ca;
                        width: 35px;
                        height: 35px;
                        top: -5px;
                        left: -5px;
                      "
                    ></span>
                    <img
                      style="border: 3px solid #035a8f"
                      v-if="stud_data.icard_temp.mother_photo.field_value"
                      :src="stud_data.icard_temp.mother_photo.field_value"
                      width="110px"
                      height="110px"
                    />
                    <span
                      v-if="stud_data.icard_temp.mother_photo.field_value"
                      style="
                        position: absolute;
                        border-right: 5px solid #f5e8ca;
                        border-bottom: 5px solid #f5e8ca;
                        width: 35px;
                        height: 35px;
                        bottom: 2.5px;
                        right: -20%;
                      "
                    ></span>
                  </center>
                </span>
                <span style="position: relative" v-else>
                  <center>
                    <span
                      style="
                        position: absolute;
                        border-top: 5px solid #f5e8ca;
                        border-left: 5px solid #f5e8ca;
                        width: 35px;
                        height: 35px;
                        top: -5px;
                        left: -5px;
                      "
                    ></span>
                    <img
                      style="border: 3px solid #035a8f"
                      :src="stud_data.icard_temp.mother_photo.field_value"
                      alt=""
                      width="110px"
                      height="110px"
                    />
                    <span
                      style="
                        position: absolute;
                        border-right: 5px solid #f5e8ca;
                        border-bottom: 5px solid #f5e8ca;
                        width: 35px;
                        height: 35px;
                        bottom: 2.5px;
                        right: -20%;
                      "
                    ></span>
                  </center>
                </span>
                <span
                  v-if="stud_data.icard_temp.mother_first_name"
                  class="text-center"
                >
                  <h5
                    style="
                      color: #035a8f;
                      height: 50px;
                      font-size: 13px;
                      line-height: 12px;
                      width: 110px;
                      font-weight: bold;
                      padding-top: 2px;
                    "
                  >
                    {{ stud_data.icard_temp.mother_first_name.field_value }}
                  </h5>
                </span>

                <div
                  class="text-center"
                  style="margin-top: -10px"
                  v-if="stud_data.icard_temp.mother_mobile_no"
                >
                  <h5>
                    <span style="font-weight: 400; font-size: 14px">
                      Contact No. : </span
                    ><br />
                    <span style="font-size: 14px">{{
                      stud_data.icard_temp.mother_mobile_no.field_value
                    }}</span>
                  </h5>
                </div>
              </div>
            </div>
            <div
              v-if="stud_data.icard_temp.address_for_icard"
              class="col-12"
              style="
                margin: 7px 8px 7px 13px;
                font-size: 14px;
                height: 13px;
                padding-right: 14px;
              "
            >
              <span> Address: </span>
              <span>
                <b>{{ stud_data.icard_temp.address_for_icard.field_value }} </b>
              </span>
            </div>
            <div
              class="row ml-0"
              style="
                background-color: #035a8f;
                height: 19px;
                position: relative;
                top: 75px;
              "
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import QrcodeVue from "qrcode.vue";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  components: {
    QrcodeVue,
  },
  data: () => ({
    comp_load: false,
    stud_list: null,
    radios: null,
    stud_data: null,
    child_data: null,
    icard_data: [],
    std: null,
    div: null,
    common_data: null,
    status: null,
    itemsPerPage: 0, // Number of items per page
    currentPage: 1,
  }),
  mounted() {
    // thisstud_data = JSON.parse(localStorage.getItem(stud_data"));

    this.std = localStorage.getItem("icard_std_id");
    this.div = localStorage.getItem("icard_div_id");
    this.status = localStorage.getItem("icard_learner_status");
    this.itemsPerPage = localStorage.getItem("itemsPerPage");
    this.icardGenerateStudent();
  },
  computed: {
    totalPages() {
      return Math.ceil(this.icard_data.length / this.itemsPerPage);
    },
    displayedItems() {
      const start = (this.currentPage - 1) * parseInt(this.itemsPerPage);
      const end = start + parseInt(this.itemsPerPage);
      return this.icard_data.slice(start, end);
    },
  },

  methods: {
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
    onload() {},
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    icardGenerateStudent() {
      const data = {
        std: this.std,
        div: this.div,
        status: this.status,
        for: "bulk",
        usertype: "Student",
      };
      this.comp_load = false;
      axios
        .post("/Icard/generateIcardCommon", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.icard_data = res.data.icard_data;
            this.common_data = res.data.common_data;
          } else {
            alert(res.data.snackbar);
          }
          this.comp_load = true;
        })
        .catch((error) => {
          alert("Somthing went wrong!!!");
          this.comp_load = false;
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
  },
};
</script>

<style scoped>
@media print {
  .pagebreak {
    page-break-before: always !important;
    height: 200px;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }

  @page {
    /* margin: 0mm; */
    margin: -1.2645833mm;
    /* size: 85mm 55mm; */
    size: 53mm 85mm;
  }
}
</style>
